import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  border: none;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: ${({ theme }) => (theme as IOcAppTheme).color.primary};
  font-size: ${({ theme }) => (theme as IOcAppTheme).font.size.default};
  font-weight: ${({ theme }) => (theme as IOcAppTheme).font.weight.medium};
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => (theme as IOcAppTheme).color.primary};
    color: ${({ theme }) => (theme as IOcAppTheme).color.sourcesHeaderCountText};
  }
`;

export const ChevronIcon = styled.svg<{ $isExpanded: boolean }>`
  width: 12px;
  height: 12px;
  transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(90deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
`;

